import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  RESIN_ORDER_ERROR,
  RESIN_ORDER_LOADING,
  RESIN_ORDER_SUCCESS,
  RESIN_ORDER_CANCEL,
  RESIN_ORDER_START,
  RESIN_SPECULATIVE_ERROR,
  RESIN_SPECULATIVE_SUCCESS,
  RESIN_SPECULATIVE_CANCEL,
  RESIN_SPECULATIVE_START,
} from '@src/app/accounts/resin-order/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';

export type State = {
  resinOrderLoading: boolean;
  resinOrderResult: any;
  resinSpeculativeResult: any;
};

export const reducer = combineReducers<State, RootAction>({
  resinOrderLoading: (state = false, action) => {
    switch (action.type) {
      case RESIN_ORDER_ERROR:
      case RESIN_SPECULATIVE_SUCCESS:
      case RESIN_SPECULATIVE_ERROR:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case RESIN_ORDER_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  resinOrderResult: (state = null, action) => {
    switch (action.type) {
      case RESIN_ORDER_ERROR:
      case RESIN_ORDER_SUCCESS:
        return action.payload;
      case RESIN_ORDER_CANCEL:
      case RESIN_ORDER_START:
        return null;
      default:
        return state;
    }
  },
  resinSpeculativeResult: (state = null, action) => {
    switch (action.type) {
      case RESIN_SPECULATIVE_ERROR:
      case RESIN_SPECULATIVE_SUCCESS:
        return action.payload;
      case RESIN_SPECULATIVE_CANCEL:
      case RESIN_SPECULATIVE_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/resin-order/reducer.ts